import {Component, Inject, Optional} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DeviceDetectorService} from "../../../core/services/device-detector.service";

@Component({
  selector: 'app-modal-descricao',
  templateUrl: './modal-descricao.component.html',
  styleUrls: ['./modal-descricao.component.scss']
})
export class ModalDescricaoComponent {
    observacao: string = '';
  constructor(
    private bottomSheetRef: MatBottomSheetRef<ModalDescricaoComponent>,
    public dialogRef: MatDialogRef<ModalDescricaoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public dataBottom,
    protected deviceDetectorService: DeviceDetectorService,
  ) {
    if(!this.deviceDetectorService.isMobile()) {
     this.observacao = this.data.observacao;
    } else {
      this.observacao = this.dataBottom.observacao;
    }
  }

  fechar(): void {
    if(!this.deviceDetectorService.isMobile()) {
      this.dialogRef.close();
    } else {
      this.bottomSheetRef.dismiss();
    }
  }
}
